/*
 * @Author: liusha
 * @Date: 2023-11-07 10:55:29
 * @LastEditors: lihwang
 * @LastEditTime: 2023-12-11 16:58:11
 * @Description: banner
 */
import React from 'react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import { BannerRespDTO } from '@/service/market';
import Zuoleft2 from '@/common/icons/Zuoleft2';
import Zuoleft1 from '@/common/icons/Zuoleft1';
import { urlAddChannel } from '@/utils';
import styles from './index.module.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
interface BannerProps {
    activityData: BannerRespDTO[];
}
interface SwiperRefProps {
    slideNext: () => void;
    slidePrev: () => void;
}
const iconStyle = {
    cursor: 'pointer'
};
const ActivityBanner: React.FC<BannerProps> = ({ activityData }) => {
    const swiperRef = React.useRef<SwiperRefProps>();
    const pagination = {
        clickable: false,
        position: 'left',
        renderBullet: function (_index: number, className: string) {
            return `<span class="${className} ${styles.paginationButton}"></span>`;
        }
    };
    const goActivity = (jumpUrl?: string) => {
        if (jumpUrl) {
            window.open(urlAddChannel(jumpUrl));
        }
    };
    return (
        <div className={styles.container}>
            {activityData.length > 1 && (
                <>
                    <div
                        className={classNames(styles.slideLeft, styles.slider)}
                        onClick={() => swiperRef.current?.slidePrev()}
                    >
                        <Zuoleft1 fontSize={40} style={iconStyle} />
                    </div>
                    <div
                        className={classNames(styles.slideRight, styles.slider)}
                        onClick={() => swiperRef.current?.slideNext()}
                    >
                        <Zuoleft2 fontSize={40} style={iconStyle} />
                    </div>
                </>
            )}
            <Swiper
                className={styles.swiper}
                loop={true}
                pagination={activityData.length > 1 ? pagination : false}
                slidesPerView={1}
                autoplay={{
                    delay: 5000
                }}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                modules={
                    activityData.length > 1
                        ? [Autoplay, Pagination]
                        : [Autoplay]
                }
            >
                {activityData.map((item, index) => (
                    <SwiperSlide
                        key={index}
                        style={{
                            width: '100%'
                        }}
                    >
                        <img
                            className={styles.img}
                            src={item.picUrl}
                            alt={`Slides ${index + 1}`}
                            onClick={() => goActivity(item.jumpUrl)}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};
export default ActivityBanner;
